import "./lib/jquery_setup";
import "./lib/chart.min";
import "./registration/registrations";
import "./lib/jquery.modal";

import initializeEnvBar from "./utils/envBar";

initializeEnvBar();
